export const socials = {
  github: {
    label: 'GitHub',
    href: 'https://github.com/oscarossesa',
  },
  linkedin: {
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/in/oscarosses',
  },
  contact: {
    label: 'Get in touch',
    email: 'oscarossesa@gmail.com',
    subject: 'Freelance project — Oscar Osses',
    body: 'Hi Oscar,\n\nI have a freelance / independent project I would like to discuss.\n\nProject overview:\nTimeline:\nBudget range (optional):\n\nBest regards,',
  },
  cv: {
    label: 'Request my CV',
    email: 'oscarossesa@gmail.com',
    subject: 'CV request — Oscar Osses',
    body: 'Hi Oscar,\n\nI would like to request a copy of your CV.\n\nBest regards,',
  },
}

export const skills = [
  {
    category: 'Backend',
    items: ['C# / .NET', 'Java', 'Spring Boot', 'REST APIs', 'SQL Server'],
  },
  {
    category: 'Frontend',
    items: ['React', 'TypeScript', 'Redux', 'JavaScript'],
  },
  {
    category: 'Cloud & systems',
    items: [
      'AWS',
      'Azure DevOps',
      'Red Hat OpenShift',
      'Microservices',
      'Distributed Systems',
    ],
  },
  {
    category: 'Practices',
    items: ['Agile', 'Code review', 'Mentoring', 'CI/CD'],
  },
]

export const experience = [
  {
    company: 'MatchMyCourse',
    role: 'Contract Full Stack Developer',
    period: 'Apr 2025 — Jul 2025',
    location: 'Dublin, Ireland',
    summary:
      'Built a course-booking experience for English-language schools — selection, filters, pricing, promotions and reservations — working closely with stakeholders on a short contract. Stack: React, TypeScript, Node.js and MongoDB.',
  },
  {
    company: 'ChileCompra',
    role: 'Senior Full Stack Developer',
    period: '2015 — 2024',
    location: 'Santiago, Chile',
    summary:
      'Shipped product modules on Mercado Público, Chile’s public-procurement marketplace used by 1,000+ organisations and 119,000+ suppliers (~8,000 concurrent users). Built cross-institution APIs and integrations, raised quality through standards and code review, and mentored engineers across a 100+ microservice landscape (C#, .NET, Java, Spring Boot, React, SQL Server).',
  },
  {
    company: 'ChileCompra',
    role: 'Backend Developer',
    period: '2010 — 2015',
    location: 'Santiago, Chile',
    summary:
      'Kept the national Framework Agreements platform stable by fixing production issues for a large government user base, building SOAP/XML integrations, and introducing a criticality-based backlog that improved response times.',
  },
]

export const getCvMailtoHref = () => {
  const { email, subject, body } = socials.cv
  const params = new URLSearchParams({
    subject,
    body,
  })

  return `mailto:${email}?${params.toString()}`
}

export const getContactMailtoHref = () => {
  const { email, subject, body } = socials.contact
  const params = new URLSearchParams({
    subject,
    body,
  })

  return `mailto:${email}?${params.toString()}`
}
